import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { useForm } from '../../../hooks/useForm'
import { ApiUrl } from '../../../services/ApiRest';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

export const BeginningOfDay = () => {
    const today = new Date().toISOString().split("T")[0];
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [data, setdata] = useState([]);
    const [bDayId, setbDayId] = useState();
    const [formD, setformD] = useState({
        date_bd: '',
        description_bd: '',
    });

    const onSubmitBeginningDay = async (event) => {
        event.preventDefault();
        setButtonDisabled(true);
        console.log('VALOR ENVIADO:', formD.description_bd);
        console.log('FECHAS ENVIADA:', formD.date_bd);
        const f = new FormData();
        f.append("description_bd", formD.description_bd);
        f.append("date_bd", formD.date_bd);
        console.log('DOSTOS ENVIADOS del backend:', Object.fromEntries(f));
        await axios.post(ApiUrl + 'beginning-day-add', f)
            .then(response => {

                var resp = response.data;
                console.log(resp);
                if (resp.success) {
                    toast.success("Información agregada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                    deleteTable();
                    dataList();
                    setformD({
                        date_bd: '',
                        description_bd: '',
                    });
                } else {
                    toast.error("La información no se ha agregado", { position: toast.POSITION.BOTTOM_RIGHT });
                }
            })
            .catch(e => {
                console.log(e)
                toast.error("" + e + "!", { position: toast.POSITION.BOTTOM_RIGHT });
            })
            .finally(() => {
                setButtonDisabled(false); // Habilitar el botón después de que la solicitud haya finalizado
            });
    }

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setformD({
            ...formD,
            [name]: value
        })
    }

    const onSubmitUpdateBeginningDay = async (event) => {
        event.preventDefault();
        setButtonDisabled(true);
        const f = new FormData();
        f.append("date_bd", formD.date_bd);
        f.append("description_bd", formD.description_bd);
        console.log('DOSTOS ENVIADOS del backend UPDATE EGRESS:', Object.fromEntries(f));
        try {
            const response = await axios.post(ApiUrl + `beginning-day-update/${formD.beginning_days_id}`, f);
            const resp = response.data;
            console.log('RESPUESTS UPDATE EGRESs:', resp);
            if (resp.success) {
                toast.success("Información actualizada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                dataList();
                deleteTable();
            } else {
                toast.error("Información no actualizada", { position: toast.POSITION.BOTTOM_RIGHT });
            }
        } catch (error) {
            console.log(error);
            toast.error("" + error + "!", { position: toast.POSITION.BOTTOM_RIGHT });
        } finally {
            setButtonDisabled(false);
        };
    };

    const dataList = async () => {
        try {
            const response = await axios.get(ApiUrl + `beginning-day-list`);
            const responseData = response.data;
            setdata(responseData);
            const script = document.createElement("script");
            script.src = `/assets/dataTable/dataTable.js`;
            script.async = true;
            document.body.appendChild(script);
        } catch (error) {
            console.error(error);
        }
    };

    const deleteTable = () => {
        const script1 = document.createElement("script");
        script1.src = `/assets/dataTable/datatable-destroy.js`;
        script1.async = true;
        document.body.appendChild(script1);
    }

    const deleteBeginningDay = async (beginning_days_id) => {
        try {
            const response = await axios.post(ApiUrl + `beginning-day-delete/${beginning_days_id}`);
            const resp = response.data;
            if (resp.success === true) {
                toast.success("Producto eliminado exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                dataList();
                deleteTable();
            } else {
                toast.error("Producto no eliminado", { position: toast.POSITION.BOTTOM_RIGHT });
            }
        } catch (error) {
            console.log(error);
            toast.error("" + error + "!", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    useEffect(() => {
        dataList();
    }, []);

    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col-12 col-md-4 text-md-start">
                                    <b> INICIO DE PERÍODO DE VENTA </b>
                                </div>
                                <div className="col-12 col-md-4 text-center">
                                    <b> HOY: {today} </b>
                                </div>
                                <div className="col-12 col-md-4 d-flex flex-column flex-md-row justify-content-md-end gap-2 mt-2 mt-md-0">
                                    <button className="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#addBeginningDay">
                                        <b>AGREGAR NUEVO</b><i className="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="card-body table-responsive">
                            <table className="table table-hover" id="dataTable">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Inicio de caja</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(data) &&
                                        data.map((item) => (
                                            <tr key={item.beginning_days_id}>
                                                <td>{item.date_bd}</td>
                                                <td>{parseFloat(item.description_bd || 0).toFixed(2)}</td>
                                                <td>
                                                    <button className="btn btn-outline-primary"
                                                        onClick={() => {
                                                            const formattedDate = item.date_bd ? new Date(item.date_bd).toISOString().split("T")[0] : "";
                                                            setformD({
                                                                date_bd: formattedDate,
                                                                description_bd: item.description_bd || "",
                                                                beginning_days_id: item.beginning_days_id || null,
                                                            });
                                                        }}
                                                        data-bs-toggle="modal" data-bs-target="#editBeginningDay">
                                                        <i className="fa fa-edit"></i>
                                                    </button>
                                                    <button
                                                        className="btn btn-outline-danger"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#deleteBeginningDay"
                                                        onClick={() => {
                                                            setbDayId(item.beginning_days_id);
                                                        }}>
                                                        <i className="fas fa-trash-alt"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* AGREGAR INICIO DE CAJA */}
            <div className="modal fade" id="addBeginningDay" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={onSubmitBeginningDay}>
                            <div className="modal-header">
                                <p className="modal-title" id="exampleModalLabel"><b>AGREGAR VALOR</b></p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 col-md-6'>
                                            <div className="">
                                                <label className="form-label">Fecha</label>
                                                <input type="date" name='date_bd' className="form-control" value={formD.date_bd} onChange={onInputChange} required ></input>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <div className="">
                                                <label className="form-label">Inicio de caja</label>
                                                <input
                                                    type="text"
                                                    name='description_bd'
                                                    className="form-control"
                                                    value={formD.description_bd}
                                                    onChange={(e) => {
                                                        let value = e.target.value;
                                                        // Permitir solo números y punto decimal
                                                        if (!/^\d*\.?\d*$/.test(value)) return;
                                                        // Limitar a 6 dígitos antes del punto decimal
                                                        const parts = value.split(".");
                                                        if (parts[0].length > 6) return;
                                                        setformD({
                                                            ...formD,
                                                            description_bd: value
                                                        });
                                                    }}
                                                    required
                                                    placeholder='00.00'
                                                    onBlur={(e) => {
                                                        setformD({
                                                            ...formD,
                                                            description_bd: parseFloat(e.target.value || 0).toFixed(2)
                                                        });
                                                    }} >

                                                </input>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary" > Aceptar</button> &nbsp;
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* EDITAR INICIO DE CAJA */}
            <div className="modal fade" id="editBeginningDay" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={onSubmitUpdateBeginningDay}>
                            <div className="modal-header">
                                <p className="modal-title" id="exampleModalLabel"><b>EDITAR VALOR</b></p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 col-md-6'>
                                            <div className="">
                                                <label className="form-label">Fecha</label>
                                                <input type="date" name='date_bd' className="form-control" onChange={onInputChange} value={formD.date_bd || ""} ></input>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <div className="">
                                                <label className="form-label">Inicio de caja</label>
                                                {/* <input type="text" name='description_bd' className="form-control" onChange={onInputChange} required value={formD.description_bd !== "" ? parseFloat(formD.description_bd).toFixed(2) : ""}  ></input> */}
                                                <input
                                                    type="text"
                                                    name='description_bd'
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        let value = e.target.value;
                                                        // Permitir solo números y punto decimal
                                                        if (!/^\d*\.?\d*$/.test(value)) return;
                                                        // Limitar a 6 dígitos antes del punto decimal
                                                        const parts = value.split(".");
                                                        if (parts[0].length > 6) return;
                                                        setformD({
                                                            ...formD,
                                                            description_bd: value
                                                        });
                                                    }}
                                                    required
                                                    value={formD.description_bd || ""}
                                                    onBlur={(e) => {
                                                        setformD({
                                                            ...formD,
                                                            description_bd: parseFloat(e.target.value || 0).toFixed(2)
                                                        });
                                                    }} >
                                                </input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary" > Aceptar</button> &nbsp;
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* ELIMINAR INICIO DE CAJA */}
            <div className="modal fade" id="deleteBeginningDay" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">ELIMINAR SUSCRIPCIÓN</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            ¿Está seguro que desea eliminar?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => deleteBeginningDay(bDayId)}>Aceptar</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer theme="colored" />

        </div>
    )
}
